module.exports = __webpack_public_path__ + "img/dsci0083.f3e6aed9.jpg";